import { render, staticRenderFns } from "./ReturnView.vue?vue&type=template&id=70195d66&scoped=true&"
import script from "./ReturnView.vue?vue&type=script&lang=js&"
export * from "./ReturnView.vue?vue&type=script&lang=js&"
import style0 from "./ReturnView.vue?vue&type=style&index=0&id=70195d66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70195d66",
  null
  
)

export default component.exports